/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useReducer } from "react";
import LoaderNew from "../components/LoaderNew";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { initialState, reducer } from "../components/ReducerComponent";
import {
  clog,
  getEncriptedLoginData,
  getRedirectAfterLogin,
  clearRedirectAfterLogin,
} from "../lib/utils";
import { updateAppVersion } from "../lib/versionCheck";

// SocialLogin.js
// Purpose: Handles social login (e.g., Google) callback logic, processes authentication codes, manages cookies, and redirects users based on login/signup flow.
// Logic: Uses React hooks and effects to process URL parameters, call authentication APIs, and manage login state and navigation.

function SocialLogin() {
  const navigate = useNavigate();
  const [loadingState, dispatch] = useReducer(reducer, initialState);

  // Debug: Check for redirect info on component mount
  useEffect(() => {
    const redirectInfo = getRedirectAfterLogin();
    console.log("SocialLogin - Redirect info from localStorage:", redirectInfo);
  }, []);

  // Function to set the expiration cookie
  const setExpirationCookie = (expirationDate) => {
    if (expirationDate) {
      Cookies.set("expirationDate", expirationDate, {
        expires: new Date(expirationDate),
      });
    }
  };
  // Function to handle sign-up button click
  const signUpButton = async (code, email, act) => {
    let data = {
      code: code,
      email: email,
      referrer: localStorage.getItem("referrer") || null,
      page_url: localStorage.getItem("page_url") || null,
    };
    if (act == 2) {
      let visonsignupplan = localStorage.getItem("visonsignupplan");
      data["plan_id"] = parseInt(visonsignupplan || null);
    }
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/vison/login/social`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      });
      if (response.data.success) {
        if (act == 2) {
          localStorage.setItem("continue_with_google", "true");
        }
        localStorage.setItem(
          "login_data",
          JSON.stringify(getEncriptedLoginData(response.data.data))
        );
        localStorage.setItem("login_token", response.data.token);

        // Update app version after successful login
        updateAppVersion();

        let data = response.data.data;
        clog(data, "data");
        if (data?.workspacess?.length == 0) {
          localStorage.setItem("workspaces_list", JSON.stringify([]));
          localStorage.setItem("selected_workspace", JSON.stringify({}));
        }
        setExpirationCookie(
          response.data.data.resp_user.subscription_expire_date
        );
        if (localStorage.getItem("price_id") || localStorage.getItem("visonsignupplan") == "pay-as-you-go") {
          // Handle case when price_id is present
          let price_id = localStorage.getItem("price_id");
          // call /api/user/payment/create api with request {"price_id": price_id} then we will get redirect uri
          try {

            let payload = {
        price_id : price_id
      };
      if (localStorage.getItem("visonsignupplan") == "pay-as-you-go") {
        payload.mode_type = "setup";
        payload.price_id = null;
      }

            let responsePayment = await axios({
              url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/payment/create`,
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                jwt_token: response?.data?.token,
              },
              data: payload,
            });
            if (
              !responsePayment.data.error &&
              responsePayment.data.redirect_url
            ) {
              localStorage.setItem(
                "stripe_vision_session_id",
                responsePayment.data.session_id
              );
              // Redirect to the payment page
              window.location.href = responsePayment.data.redirect_url;
            } else {
              dispatch({
                type: "ERROR",
                data: {
                  errorMessage:
                    responsePayment?.data?.message || "Payment failed",
                },
              });
              navigate("/script", {
                replace: true,
              });
            }
          } catch (error) {
            clog(error);
            dispatch({
              type: "ERROR",
              data: {
                errorMessage:
                  error?.response?.data?.message || "Payment failed",
              },
            });
            navigate("/script", {
              replace: true,
            });
          }
        } else {
          // Check for redirect info from localStorage (could be from workspace invitation)
          const redirectInfo = getRedirectAfterLogin();

          if (redirectInfo?.from === "dynamic_page" && redirectInfo?.url) {
            // Clear the redirect info after using it
            clearRedirectAfterLogin();

            navigate(`/${redirectInfo.url}`, {
              replace: true,
            });
          } else {
            // Clear any stale redirect info
            clearRedirectAfterLogin();

            navigate("/script", {
              replace: true,
            });
          }
        }
      } else {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
      clog(error);
    } finally {
      localStorage.removeItem("referrer");
      localStorage.removeItem("page_url");
    }
  };
  // Effect to process URL parameters and handle social login
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");
    let email = searchParams.get("email");
    let act = searchParams.get("act");
    // 1=login
    // 2=signup
    // clog(state, "state");
    // if search param came "undefined" then redirect to login page
    if (
      code == "undefined" ||
      email == "undefined" ||
      act == "undefined" ||
      !code ||
      !email ||
      !act
    ) {
      navigate("/?error=login not allowed from your email id");
      return;
    }

    if (code && email && act) {
      signUpButton(code, email, act);
    } else {
      navigate("/");
    }
  }, []);
  return (
    <div>
      <LoaderNew />
    </div>
  );
}

export default SocialLogin;
